/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import $ from 'jquery';
import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import TimerActions from 'notebook/protocols/timers/TimerActions';
import * as AudioBeep from 'notebook/protocols/viewer/AudioBeep';
import ToolboxActiveTimer from 'notebook/protocols/viewer/ToolboxActiveTimer';

import {Timer} from './TimerConstants';

interface Props {
  timers: Array<Timer>;
}

class TimerList extends React.Component<Props> {
  static displayName = 'TimerList';

  static defaultProps = {
    timers: [],
  };

  audioPrimed = false;
  trayAudioRef = React.createRef<AudioBeep.Component>();

  playAudio = (): Promise<void> =>
    (ReactDOM.findDOMNode(this.trayAudioRef.current) as HTMLAudioElement).play();

  pauseAudio = (): void => {
    (ReactDOM.findDOMNode(this.trayAudioRef.current) as HTMLAudioElement).pause();
  };

  // Returns a list of all timers annotated with the proper update and remove methods
  allTrayTimers = (): Array<Timer> => {
    const allTimers = Array.from(this.props.timers).map((timer) =>
      // eslint-disable-next-line no-restricted-syntax
      _.extend(
        {
          requestChange: TimerActions.updateTimer.bind(TimerActions, timer, timer.id),
          requestDelete: TimerActions.removeTimer.bind(TimerActions, timer, timer.id),
        },
        timer
      )
    );
    return allTimers ?? [];
  };

  // Copied from protocols/viewer/step-by-step.js
  activeTrayTimer = (): Timer | null => {
    let out = null;
    let earliestEnd = null;
    for (const timer of Array.from(this.allTrayTimers())) {
      // Done timer always wins.
      var end;
      if (timer.startMS === 0) {
        // High priority end by using timestamp of 0
        end = 0;
        // Non-inline timer has priority over inline timer so that we can play the audio.
        if (earliestEnd == null || end < earliestEnd || (out?.inlineCopy && !timer.inlineCopy)) {
          out = timer;
          earliestEnd = end;
        }
        continue;
      }
      if (!timer.startMoment) {
        continue;
      }
      end = timer.startMoment.unix() * 1000 + timer.startMS;
      if (earliestEnd == null || end < earliestEnd) {
        out = timer;
        earliestEnd = end;
      }
    }

    // @ts-expect-error ts-migrate(2454) FIXME: Variable 'audioPrimed' is used before being assign... Remove this comment to see the full error message
    // eslint-disable-next-line block-scoped-var
    if (out != null && !audioPrimed && this.trayAudioRef.current != null) {
      AudioBeep.prime(ReactDOM.findDOMNode(this.trayAudioRef.current) as HTMLAudioElement);
      var audioPrimed = true;
    }
    return out;
  };

  timerRunning = (): boolean => this.props.timers.some((timer) => timer.startMoment != null);

  unloadHandler = (): string | undefined => {
    window.beforeUnloadType = 'TimerList';
    if (this.timerRunning()) {
      return 'There is currently a timer running.';
    }
    return undefined;
  };

  componentDidMount(): void {
    $(window).on('beforeunload', this.unloadHandler);
  }

  componentWillUnmount(): void {
    $(window).off('beforeunload', this.unloadHandler);
  }

  msLeft = (timer: Timer): number => {
    let msElapsed;
    if (timer.startMoment) {
      msElapsed = moment().diff(timer.startMoment);
    } else {
      msElapsed = 0;
    }
    return Math.max(0, timer.startMS - msElapsed);
  };

  toggleTimer = (): void => {
    const activeTimer = this.activeTrayTimer() as Timer;

    // If the timer is still in progress, pause it. Otherwise, reset it
    if (activeTimer.startMS > 0) {
      TimerActions.updateTimer(activeTimer.id, {
        startMoment: null,
        startMS: this.msLeft(activeTimer),
      });
    } else {
      TimerActions.updateTimer(activeTimer.id, {
        startMoment: null,
        startMS: activeTimer.originalMS,
      });
    }
  };

  render(): JSX.Element | null {
    const activeTimer = this.activeTrayTimer();
    if (activeTimer != null) {
      return (
        <div className="statusbar-label btn btn-af-default trayTimer-statusBarLabel">
          <AudioBeep.Component ref={this.trayAudioRef} />
          <div className="trayTimer-toolboxActiveTimer" onClick={this.toggleTimer}>
            <ToolboxActiveTimer
              timer={activeTimer}
              onRequestPlayAudio={() => {
                if (this.trayAudioRef.current != null) {
                  this.playAudio();
                }
              }}
              onRequestPauseAudio={() => {
                if (this.trayAudioRef.current != null) {
                  this.pauseAudio();
                }
              }}
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default TimerList;
